module.exports = __webpack_public_path__ + "img/coin.a3aa84bb.svg";